'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const feed = css`
  padding: 0 !important;
  background: ${theme.colors.peoople['gris-medio-claro']};
  position: relative;
`;

export const video = css`
  background: black;
`;

export const ads = css`
  width: 300px;
  height: 250px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const header = css`
  column-gap: 0.5rem;
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  display: grid;
  color: white;
  grid-template-areas:
    'logo title'
    '. subtitle';
  z-index: 10;
`;

export const logo = css`
  width: 42px;
  height: 42px;
  grid-area: logo;
`;

export const title = css`
  display: flex;
  align-items: center;
  grid-area: title;
  font-size: 24px;
  font-weight: 600;
`;

export const subtitle = css`
  grid-area: subtitle;
`;

export const landscape = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
